import { Action, createReducer, on } from '@ngrx/store';
import { IsUserDeceasedRequest, IsUserDeceasedResponse } from '../models/deceased.model';
import { IGenericError, ErrorResponse } from '../../../core/models/generic-models';
import { checkIfUserDeceasedRequest, checkIfUserDeceasedFailure, checkIfUserDeceasedResponse } from '../actions/deceased.actions';

export const deceasedFeatureKey = 'deceased';

export interface DeceasedState {
  isDeceasedRequest: IsUserDeceasedRequest;
  isDeceasedResponse: IsUserDeceasedResponse;
  isDeceasedFailure: IGenericError<ErrorResponse>;
}

export const initialState: DeceasedState = {
  isDeceasedRequest: undefined,
  isDeceasedResponse: undefined,
  isDeceasedFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(checkIfUserDeceasedRequest, (state, action) => ({
    ...state,
    isDeceasedRequest: action.request
  })),
  on(checkIfUserDeceasedResponse, (state, action) => ({
    ...state,
    isDeceasedResponse: action.response
  })),
  on(checkIfUserDeceasedFailure, (state, action) => ({
    ...state,
    isDeceasedFailure: action.error
  }))
);

export const getUserDeceasedRequest = (state: DeceasedState) => state.isDeceasedRequest;
export const getUserDeceasedResponse = (state: DeceasedState) => {
  return state.isDeceasedResponse;
};

export const getUserDeceasedFailure = (state: DeceasedState) => state.isDeceasedFailure;
